import { useMediaQuery } from 'react-responsive';
import * as S from './DealRoomLanding.styles';
import { Avatar } from '@app/components/common/Avatar/Avatar';
import appLogo from 'assets/logo.jpg';
import mainLogo from 'assets/main-logo.svg';
import DealRoomFooter from './DealFooter/DealRoomFooter';
import { useTranslation } from 'react-i18next';
import { IDealRoomShare } from '@app/interfaces/deal-room';
import { isObject } from 'lodash';
import { getDealRoomFirstBuildingText, getUserFullName } from '@app/utils/utils';
import { IUser } from '@app/interfaces/user';

interface IDealRoomDefaultProps {
  dealRoomAgent: IDealRoomShare;
}

export const DealRoomDefault: React.FC<IDealRoomDefaultProps> = ({ dealRoomAgent }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const responsible =
    dealRoomAgent?.responsible && isObject(dealRoomAgent?.responsible) ? (dealRoomAgent?.responsible as IUser) : null;

  return (
    <>
      <S.Header scrolled={false}>
        <h2>
          {isMobile ? (
            <Avatar key="logo" src={appLogo} size={40} />
          ) : (
            <>
              <img className="app-logo" src={mainLogo} alt="Logo" />
            </>
          )}
        </h2>
      </S.Header>
      <S.Body scrolled={false}>
        <S.LandingContainer>
          <S.LandingContent>
            <h1
              dangerouslySetInnerHTML={{
                __html: t('dealRooms.landing.linkNotAvailable', {
                  companyPhone: '<a href="tel:03-5020100" class="no-break">03-5020100</a>',
                  buildingAddress: getDealRoomFirstBuildingText(dealRoomAgent),
                  agentName: responsible ? getUserFullName(responsible) : '',
                  agentPhone:
                    responsible && (responsible?.workPhone || responsible?.phone)
                      ? `<a href="tel:${responsible?.workPhone || responsible?.phone}" class="no-break">${
                          responsible?.workPhone || responsible?.phone
                        }</a>`
                      : '',
                  agentEmail:
                    responsible && responsible?.email
                      ? `<a class="no-break" href="mailto:${responsible?.email}">${responsible?.email}</a>`
                      : '',
                }),
              }}
            />
          </S.LandingContent>
        </S.LandingContainer>
      </S.Body>
      <DealRoomFooter />
    </>
  );
};
